import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const fichiersJustificatifsEndpoint = API_ROUTE.SAUVEGARDER_FICHIERS;

interface VersementJustificatifsPostData {
  idSouscription: number;
  typeDocumentIdentite: string;
  justificatifIdentiteRecto: string;
  justificatifIdentiteVerso: string;
  justificatifTelephone: string;
  justificatifOrigineFonds: string;
}

export const getFaireVersementJustificatifsSauvegarder = async (
  versementJustificatifsPost: VersementJustificatifsPostData
) => {
  const versementData = JSON.parse(sessionStorage.parcoursVersementData);
  const response = await axios.post(
    `${apiBaseUrl}${fichiersJustificatifsEndpoint}`,
    {
      idSouscription: versementJustificatifsPost.idSouscription,
      typeDocumentIdentite: versementJustificatifsPost.typeDocumentIdentite,
      'justificatif-identite-1-recto': versementJustificatifsPost.justificatifIdentiteRecto,
      'justificatif-identite-1-verso': versementJustificatifsPost.justificatifIdentiteVerso,
      'justificatif-telephone': versementJustificatifsPost.justificatifTelephone,
      'justificatif-origine_fonds': versementJustificatifsPost.justificatifOrigineFonds,
    },
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error("Erreur lors de l'envoi du fichier");
  }
  const data = await response.data;
  return data;
};
